/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRadiationSession } from 'app/shared/model/radiation-session.model';
import { IRadiationType } from 'app/shared/model/radiation-type.model';
import { IRadiationBeamParameter } from 'app/shared/model/radiation-beam-parameter.model';
import { IRadiationDosimetry } from 'app/shared/model/radiation-dosimetry.model';
import { IRadiationTechnique } from 'app/shared/model/radiation-technique.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';

export interface ITreatmentRadiation {
  id?: string;
  administered?: boolean | null;
  immobilized?: boolean | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  plannedRadiationType?: IRadiationSession | null;
  administeredRadiationType?: IRadiationType | null;
  beamDetails?: IRadiationBeamParameter | null;
  doseDetails?: IRadiationDosimetry | null;
  techniquDetails?: IRadiationTechnique | null;
  cycle?: ITreatmentCycle | null;
}

export const defaultValue: Readonly<ITreatmentRadiation> = {
  administered: false,
  immobilized: false,
  active: false,
};
